/* eslint-disable no-underscore-dangle */
import { Button } from '@salt/components';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteProject } from '../../api/users';

const DeleteProjectModal = ({ handleDeleteProjectModalClose, project }) => {
  const navigate = useNavigate();

  const onDelete = useCallback(() => {
    deleteProject({ projectId: project.id })
      .then(() => {
        navigate(-1);
      })
      .catch(() => {
        console.error('Failed to delete project');
      });
    handleDeleteProjectModalClose();
  }, [project]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleDeleteProjectModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <div className="text-lg mb-4">Delete Project</div>
          <span className="text-base">
            Are you sure you want to delete <b>{project.name}</b>?
          </span>

          <div className="mt-4">
            <br />
            <Button
              onClick={handleDeleteProjectModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={onDelete}
              type="negative"
              className="max-w-[146px] h-[36px] ml-auto float-right"
              paddingClassName="px-6"
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteProjectModal;
